// extracted by mini-css-extract-plugin
export default {"LoadingMessageWrapper":"PlayerLoadingState_LoadingMessageWrapper__c9C0e"};